'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../enums/accordion.js');
require('../../../enums/alert.js');
require('../../../enums/avatar.js');
require('../../../enums/breakpoints.js');
require('../../../enums/button.js');
require('../../../enums/code-editor.js');
require('../../../enums/colors.js');
require('../../../enums/combobox.js');
require('../../../enums/date.js');
require('../../../enums/drag-and-drop.js');
require('../../../enums/dialog.js');
require('../../../enums/divider.js');
require('../../../enums/dropdown.js');
require('../../../enums/fieldset.js');
require('../../../enums/font-icon.js');
require('../../../enums/fonts.js');
require('../../../enums/headings.js');
var input = require('../../../enums/input.js');
require('../../../enums/keys.js');
require('../../../enums/list.js');
require('../../../enums/listbox.js');
require('../../../enums/loader.js');
require('../../../enums/margin.js');
require('../../../enums/option.js');
require('../../../enums/pill.js');
require('../../../enums/placements.js');
require('../../../enums/popout.js');
require('../../../enums/privacy.js');
require('../../../enums/radio-group.js');
require('../../../enums/status.js');
require('../../../enums/switch.js');
require('../../../enums/table.js');
require('../../../enums/tooltip.js');
require('../../../enums/transitions.js');
require('../../../enums/widths.js');
require('../../../themes/alert.js');
require('../../../themes/button.js');
require('../../../themes/checkbox.js');
require('../../../themes/divider.js');
require('../../../themes/dropdown.js');
require('../../../themes/fieldset.js');
require('../../../themes/input.js');
require('../../../themes/list.js');
require('../../../themes/listbox.js');
require('../../../themes/loader.js');
require('../../../themes/option.js');
require('../../../themes/popout.js');
require('../../../themes/switch.js');
var themes = require('../../../themes/themes.js');
require('../../../themes/tooltip.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseTextfieldWrapper = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { children , labelPosition , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-textfield__wrapper': true,
            [`bf-textfield__wrapper--label-position-${labelPosition}`]: !!labelPosition,
            [`${otherProps?.className}`]: !!otherProps?.className
        }),
        ref: ref
    }), children);
});
const Wrapper = styled__default.default(BaseTextfieldWrapper)`
  align-items: ${({ labelPosition  })=>labelPosition === input.InputLabelPositions.Left ? 'center' : 'stretch'};
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({ labelPosition  })=>labelPosition === input.InputLabelPositions.Left ? 'row' : 'column'};
  position: relative;
`;
const TextfieldWrapper = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Wrapper, _extends({}, props, {
        ref: ref
    })));
});

exports.BaseTextfieldWrapper = BaseTextfieldWrapper;
exports.TextfieldWrapper = TextfieldWrapper;
//# sourceMappingURL=textfield-wrapper.js.map
